import Icon from '../components/Icon.vue'

Icon.register({
  'money-check-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 32H32C14.3 32 0 46.3 0 64V448C0 465.7 14.3 480 32 480H608C625.7 480 640 465.7 640 448V64C640 46.3 625.7 32 608 32zM176 327.9V344C176 348.4 172.4 352 168 352H152C147.6 352 144 348.4 144 344V327.7C132.7 327.1 121.7 323.2 112.6 316.4 108.7 313.4 108.5 307.6 112.1 304.2L123.8 293C126.6 290.4 130.7 290.3 133.9 292.3 137.8 294.7 142.2 296 146.8 296H174.9C181.4 296 186.7 290.1 186.7 282.8 186.7 276.9 183.1 271.6 177.9 270.1L132.9 256.6C114.3 251 101.3 233.2 101.3 213.2 101.3 188.7 120.4 168.8 144 168.1V152C144 147.6 147.6 144 152 144H168C172.4 144 176 147.6 176 152V168.3C187.3 168.9 198.3 172.8 207.4 179.6 211.3 182.6 211.5 188.4 207.9 191.8L196.2 203C193.4 205.6 189.3 205.7 186.1 203.7 182.2 201.3 177.8 200 173.2 200H145.1C138.6 200 133.3 205.9 133.3 213.2 133.3 219.1 136.9 224.4 142.1 225.9L187.1 239.4C205.7 245 218.7 262.8 218.7 282.8 218.7 307.3 199.6 327.2 176 327.9zM416 312C416 316.4 412.4 320 408 320H296C291.6 320 288 316.4 288 312V296C288 291.6 291.6 288 296 288H408C412.4 288 416 291.6 416 296V312zM576 312C576 316.4 572.4 320 568 320H488C483.6 320 480 316.4 480 312V296C480 291.6 483.6 288 488 288H568C572.4 288 576 291.6 576 296V312zM576 216C576 220.4 572.4 224 568 224H296C291.6 224 288 220.4 288 216V200C288 195.6 291.6 192 296 192H568C572.4 192 576 195.6 576 200V216z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-check-alt.js
// module id = 3fOR
// module chunks = 144